export const EMPTY_ARR: any = [];
export const EMPTY_MATRIX: any = {};

export const HORIZON_MODE = {
  short: "short",
  long: "long",
};
